import React from 'react'
import { Carousel } from 'react-responsive-carousel'


export const Carrusel = ({imagenes}) => {

    return (
        <div style={{marginBottom: "10px"}}>
            <Carousel
                showThumbs={false}
                showStatus={false}
                autoPlay={false}
                onSwipeEnd={() => {}}
            >
                
                {
                    imagenes.map((imagen, index) => {
                        return (
                            <div key={index}>
                                <img src={`${imagenes[index]}`} alt="imagen"/>
                            </div>
                        )
                    })
                }
            </Carousel>
        </div>
    )
}
